// Hacked up version of react-page-visibility npm package, to work with preact
// instead of react (I need to get the build fixed)

import PageVisibility from './PageVisibility';
export { default as usePageVisibility } from './usePageVisibility';

export default PageVisibility;
